import { tagInfo, phraseInfo } from "./constants";

const TagButtonList = ({ tagList, onClick }) => {
  return (
    <div
      style={{
        display: "flex",
        flexDirection: "row",
        justifyContent: "center",
        gap: "30px",
        flexWrap: "wrap",
        whiteSpace: "pre-wrap",
      }}
    >
      {tagList.map((tag) => {
        return (
          <div
            key={tag}
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              padding: "10px",
              width: "110px",
              fontSize: "20px",
              borderRadius: "5px",
              backgroundColor: tagInfo[tag]
                ? tagInfo[tag].backgroundColor
                : phraseInfo[tag].backgroundColor,
              border: tagInfo[tag]
                ? "1px solid " + tagInfo[tag].color
                : "1px solid " + phraseInfo[tag].color,
              color: tagInfo[tag] ? tagInfo[tag].color : phraseInfo[tag].color,
            }}
            onClick={() => onClick(tag)}
          >
            {tagInfo[tag] ? tagInfo[tag].tagText : phraseInfo[tag].tagText}
          </div>
        );
      })}
    </div>
  );
};

export default TagButtonList;
